import { Grid, Typography } from '@mui/material';
import { SimpleShowLayout, TextField, useRecordContext } from 'react-admin';
import { AddressDetails } from 'src/lib';
import { Account } from 'src/models';

export const EntityInformation = () => {
  const record = useRecordContext<Account>();

  return (
    <>
      <Grid item xs={12} md={12}>
        <Grid container direction='row'>
          <Grid item xs={12}>
            <SimpleShowLayout>
              <Typography variant='h5'>Entity Information</Typography>
            </SimpleShowLayout>
          </Grid>
          <Grid item xs={12} md={6}>
            <SimpleShowLayout>
              <TextField source='entityInformation.name' label='Entity Name' />
            </SimpleShowLayout>
          </Grid>
          <Grid item xs={12} md={6}>
            <SimpleShowLayout>
              <TextField source='entityInformation.taxId' label='Tax ID' />
            </SimpleShowLayout>
          </Grid>
          <Grid item xs={12} md={6}>
            <SimpleShowLayout>
              <TextField source='entityInformation.phoneNumber' label='Phone Number(s)' />
            </SimpleShowLayout>
          </Grid>
          {record.entityInformation?.address && <AddressDetails record={record.entityInformation.address} />}
        </Grid>
      </Grid>
    </>
  );
};
